// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__cO4cD","additionalInfo":"AgreementModal_additionalInfo__2kQwX"};